export default __webpack_public_path__ + "static/media/cover-8.a9d14029.webp";